import { format } from "date-fns";
import Configurations from "../config";
//FB 8549
import { AppointmentType, EMRConfig, Facility, FacilityRegion, FacilitySchedule, InputFile, Provider, ProviderSchedule, SchedulesByDate, State, SupportFile,SupportFileUpload } from "../store";//FB 7541
import AccessToken, { VideoGrant } from "twilio/lib/jwt/AccessToken";
import { GetEMRURL} from "./index"; //FB 6925 KK

// Update log
// FB  6192   02/06/2023  DK  API library for PE functionality
// FB  6925   06/06/2023  KK  Upload Doc (Use smartphone)> Updating the QR code with the Dynamic Link
// FB  7413   09/25/2023  GA  Orady - Update the map link to the correct one
// FB  7385   09/15/2023  GA  Orady - email notification is not being sent for online appointment booking
// FB  7541   10/16/2023  SK  Implementing a feature that allows patients to upload clinical documents via a patient portal
// FB  8024   01/03/2024  SK  Including Recent Patient Engagement Enhancements to Patient Portal
// FB  8108   02/15/2024  KI  Scanning the virus using clamAV antivirus while uploading the pdf file in portal
// FB  8881   06/14/2024  SK   Show Billing Details in Portal for All Patients in Guest Login Interface
// FB  8936   07/02/2024  KI   Hide "Pay this" Column in Billing Screen if CALLIPAY_API_KEY is empty
// FB  9372   09/13/2024  GA  Portal UI should not call EMR APIs Directly
// FB  8549   10/21/2024  DK  TeleHealth re-work
// FB  10608  05/16/2025  KI  fixing ImmediateReminderNotification issue



export async function GetProviders(insurance_id: number, apptType: any): Promise<Provider[]> {
  let url: string = "";
  let finalList: any;
  let filteredProviders, allProviders;
  const union = (arr1: any, arr2: any, key: any) => [
    ...arr1
      .concat(arr2)
      .reduce(
        (m: any, o: any) => (m.has(o[key]) ? m : m.set(o[key], o)),
        new Map()
      )
      .values(),
  ];

  if (apptType === "telederm") {
    url = sessionStorage.getItem("EMRBaseURL") + "/" + "api/Provider/TeleHealth/GetAllProviders";
  }
  else {
    url = sessionStorage.getItem("EMRBaseURL") + "/" + "api/Provider/GetAllProviders";
  }

  const response = await fetch(url);
  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    allProviders = await response.json();

    if (insurance_id > 0) {
      allProviders = allProviders.map((key: any) => ({
        ...key,
        InsuranceAcceptance: "Out-of-Network",
      }));
      filteredProviders = await GetProvidersByInsurance(insurance_id);
      finalList = union(filteredProviders, allProviders, "EMPLOYEE_N");
    }
    else {
      finalList = allProviders;
    }
    return finalList.map((key: any) => {
      return {
        Name: `${key.EMPLOYEE_FIRST_NAME} ${key.EMPLOYEE_LAST_NAME}`,
        ID: key.EMPLOYEE_N,
        Facility_n: key.FACILITY_N,
        Bio: key.EMPLOYEE_BIO,
        JobTitle: key.EMPLOYEE_JOB_TITLE
      } as Provider;
    });
  }
}

export async function GetPatientN(apptId: any) {
  const configUrl = sessionStorage.getItem("EMRBaseURL") + "/";
  const targetUrl = configUrl + "api/GetPatient_N?id=" + apptId;
  return fetch(targetUrl).then((response) => response.json());
}

export async function GetProvidersByInsurance(insurance_id: number): Promise<Provider[]> {
  const url = sessionStorage.getItem("EMRBaseURL") + "/" + "api/Provider/GetProvidersByInsurance/" + insurance_id;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let filteredProviders = await response.json();
    filteredProviders = filteredProviders.map((key: any) => ({
      ...key,
      InsuranceAcceptance: "",
    }));

    return filteredProviders as Provider[];
  }
}

export async function UpdateEmailCellPhone(patientId: number, email: string, cellphone: string) {
  const url = sessionStorage.getItem("EMRBaseURL") + "/";
  const targetUrl =
    url +
    "api/Reminder/UpdatePatientContactInfo?patientId=" +
    patientId + "&email=" + email + "&cellphone=" + cellphone;
  const config = {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
  };
  return fetch(targetUrl, config).then((response) => response.ok);
}

export async function FetchEmailCellPhone(patientId: number) {
  const url = sessionStorage.getItem("EMRBaseURL") + "/";
  const targetUrl =
    url +
    "api/Reminder/GetPatientContactInfoByPatient_N?id=" +
    patientId;

  return fetch(targetUrl).then((response) => response.json());
}

export async function GetFacilities(insurance_id: number) {
  let url: string =
    sessionStorage.getItem("EMRBaseURL") + "/" +
    `api/Provider/GetFacilitiesByInsurance/${insurance_id}`;
  const response = await fetch(url);
  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    data = data.sort((a: any, b: any) => b.IsInsuranceAccepted - a.IsInsuranceAccepted);

    return data.map((key: any) => {
      return {
        Name: key.FACILITY_NAME,
        ID: key.Id,
        Address:
          key.FACILITY_ADDRESS +
          ", " +
          key.FACILITY_CITY +
          ", " +
          key.FACILITY_STATE,
        Phone:
          key.SCHEDULING_PHONE != null
            ? key.SCHEDULING_PHONE.replace(/[^0-9]/g, "")
            : "",
        Region: key.Facility_Region_N,
        GOOGLE_MAPS_LINK:key.GOOGLE_MAPS_LINK // FB 7413
      } as Facility;
    });
  }
}

export async function GetLocationsByDate(
  date: string,
  insurance_id: number
): Promise<[]> {
  let url: string =
    sessionStorage.getItem("EMRBaseURL") + "/" +
    `api/Provider/GetFacilitiesByDate/${date}/${insurance_id}`;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();

    return data.map((key: any) => {
      return {
        Name: key.FACILITY_NAME,
        ID: key.Id,
        Address:
          key.FACILITY_ADDRESS +
          ", " +
          key.FACILITY_CITY +
          ", " +
          key.FACILITY_STATE,
        Phone: key.SCHEDULING_PHONE,
        Region: 0,
        GOOGLE_MAPS_LINK:"" //FB 7413
      } as Facility;
    });
  }
}

export async function GetFacilityProviders(
  date: string,
  facility: number,
  insurance_id: number,	//FB 8024
  appointment_type_n : number //FB 8024
): Promise<Provider[]> {
  let url =
    sessionStorage.getItem("EMRBaseURL") + "/" +
    `api/Provider/GetSlotsByDate/${facility}/${date}/1/${insurance_id}/${appointment_type_n}`;//FB 8024

  const response = await fetch(url);
  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    data = data.reverse();

    return data.map((key: any) => {
      return {
        Name: `${key.Employee_First_Name} ${key.Employee_Last_Name}`,
        ID: key.Employee_N,
        Facility_n: 0,
        Bio: "",
        Job_title: key.Employee_Job_Title
      } as unknown as Provider;
    });
  }
}

export async function GetFacilityRegions(): Promise<FacilityRegion[]> {
  let url: string = sessionStorage.getItem("EMRBaseURL") + "/" + "api/Provider/GetFacilityRegions";
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();

    return data.map((key: any) => {
      return {
        ID: key.Id,
        Name: key.REGION_NAME,
        State: key.REGION_STATE,
      } as FacilityRegion;
    });
  }
}

export async function GetInsuranceCarriers(): Promise<[]> {
  let url: string =
    sessionStorage.getItem("EMRBaseURL") + "/" + "api/Provider/GetInsuranceCarriers";
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();

    return data.map((key: any) => {
      return {
        id: key.Id,
        name: key.INSURANCE_CARRIER_NAME,
      };
    });
  }
}

export async function GetInsurancePlans(carrier_id: number): Promise<[]> {
  let url: string =
    sessionStorage.getItem("EMRBaseURL") + "/" +
    `api/Provider/GetInsurancePlans/${carrier_id}`;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();

    return data.map((key: any) => {
      return {
        id: key.Id,
        name: key.INSURANCE_PLAN_NAME,
      };
    });
  }
}

export async function GetProviderSlotsByDate(
  startDate: string,
  location: number,
  provider: number
): Promise<any> {
  let url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/Provider/GetSlotsForProviderByDate/${startDate}/${location}/${provider}`;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    const data = await response.json();
    return data;
  }
}

export async function GetStates(): Promise<State[]> {
  let url: string = sessionStorage.getItem("EMRBaseURL") + "/" + "api/Provider/GetAllStates";
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    const data = await response.json();

    return data.map((key: any) => {
      return {
        name: key.CODE,
      };
    });
  }
}

// FB 8881 - Begin
function formatDate(dateString:any) {
  const decodedString = decodeURIComponent(dateString);
  const dateObj = new Date(decodedString);
  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
  const day = dateObj.getDate().toString().padStart(2, '0');
  const year = dateObj.getFullYear();
  return `${month}/${day}/${year}`;
}

export async function SearchPatient(patientObj: any): Promise<any> {
  const PatientUrl =
    sessionStorage.getItem("EMRBaseURL") + "/" +
    "api/Provider/GetPatient?firstName=" +
    patientObj.PatientFirstName +
    "&lastName=" +
    patientObj.PatientLastName +
    "&dob=" +
    formatDate(patientObj.PatientDOB) +
    "&gender=" +
    patientObj.PatientGender +
    "&zip=" +
    patientObj.PatientZIP;

//FB 8936
  const response:any = await fetch(PatientUrl);
  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.json();
  }
}
// FB 8881 - End
export async function GetPatientType(patientId: any): Promise<any> {
  const PatientUrl =
    sessionStorage.getItem("EMRBaseURL") + "/" +
    "api/Provider/GetPatientType?patientId=" + patientId;

  const response = await fetch(PatientUrl);
  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.json();
  }
}

export async function GetPatientTypeByApptID(apptId: number): Promise<any> {
  const PatientUrl =
    sessionStorage.getItem("EMRBaseURL") + "/" +
    "api/Provider/GetPatientTypeByApptID?apptId=" + apptId;

  const response = await fetch(PatientUrl);
  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.json();
  }
}

export async function AppointmentCount(
  appointment_date: any,
  FirstName: any,
  LastName: any,
  DOB: any,
  Gender: any
) {
  const targetUrl =
    sessionStorage.getItem("EMRBaseURL") + "/" +
    "api/Provider/GetAppointmentCount?date=" +
    format(appointment_date, "MM-dd-yyyy") +
    "&patient_first_name=" +
    FirstName +
    "&patient_last_name=" +
    LastName +
    "&dob=" +
    DOB +
    "&gender=" +
    Gender;

  const response = await fetch(targetUrl);
  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.json();
  }
}

export async function createPatient(patientObj: any, appObj: any) {
  const targetUrl = sessionStorage.getItem("EMRBaseURL") + "/" + "api/Provider/Schedule/Patient/AddPatient";

  const config = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    body: JSON.stringify(patientObj),
  };
  const response = await fetch(targetUrl, config);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let appt_n = 0;
    let data = await response.json();
    appObj.PATIENT_N = data;
    var date = new Date(appObj.APPOINTMENT_DATE);
    var x = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() - x);
    appObj.APPOINTMENT_DATE = date;
    appObj.APPOINTMENT_CHECKIN_TIME = date;
    if (appObj.PATIENT_N != 0) {
      appt_n = await createAppointment(appObj);
    }
    return appt_n;
  }
}

export async function createAppointment(appObj: any) {
  appObj.APPOINTMENT_TYPE_OF_WORK = appObj.APPOINTMENT_TYPE_NAME;
  appObj.SOURCE = appObj.SOURCE || "";
  appObj.UTC_Offset = appObj.UTC_Offset || "";
  appObj.CANCELLATION_REASON = appObj.CANCELLATION_REASON || "";
  appObj.APPOINTMENT_EXTERNAL_ID = appObj.APPOINTMENT_EXTERNAL_ID || "";
  appObj.APPOINTMENT_EXTERNAL_ID_TEXT = appObj.APPOINTMENT_EXTERNAL_ID_TEXT || "";
  const targetUrl = sessionStorage.getItem("EMRBaseURL") + "/" + "api/Provider/Schedule/BookAppointment";
  const config = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    body: JSON.stringify(appObj),
  };
  const response = await fetch(targetUrl, config);

  if (!response.ok) {
    NotifyErrorOutage();
    return 0;
  }
  else {
    let data = await response.json();
    sendReminder(data);
    return data;
  }
}

export async function removePreRegistration(id: number) {
  const targetUrl = sessionStorage.getItem("EMRBaseURL") + "/" + `api/Provider/Schedule/Preregistration/RemoveSlot?id=${id}`;
  const config = {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(targetUrl, config);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    const data = await response.json();
    return data;
  }
}

export async function GetMessage(ratingValue: any, id: any) {
  let url: string =
    sessionStorage.getItem("EMRBaseURL") + "/" +
    "api/Provider/GetFeedbackAcknowledgement?stars=" +
    ratingValue + "&id=" + id;

  const response = await fetch(url);
  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.json();
  }
}

export async function ConfirmParkinglot(apptId: any, licenseName: string) {
  var str = licenseName;
  const configUrl = (Configurations as any)[str].emrAPI;
  const targetUrl =
    configUrl +
    "api/Reminder/ParkingLotConfirmation?appointmentID=" +
    apptId;
  const config = {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
  };
  return await fetch(targetUrl, config).then((response) => response.json());
}

export async function ConfirmAppt(apptId: number, licenseName: any) {
  var str = licenseName;

  const targetUrl = sessionStorage.getItem("EMRBaseURL") + "/" + "api/Reminder/ReminderConfirmation?appointmentID=" + apptId;
  const config = {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
  };

  const response = await fetch(targetUrl, config);
  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.json();
  }
}

export async function LinkExpiry(apptId: any, licenseName: string) {
  var str = licenseName;
  const targetUrl = sessionStorage.getItem("EMRBaseURL") + "/" + "api/parkinglot/linkexpiry?id=" + apptId;
  return await fetch(targetUrl).then((response) => response.json());
}

export async function GetSchedulingPhone(apptId: any, licenseName: string) {
  const targetUrl = sessionStorage.getItem("EMRBaseURL") + "/" + "api/parkinglot/fetchSchedulingPhone?id=" + apptId;

  return await fetch(targetUrl).then((response) => response.json());
}

export async function GetPatientName(apptId: any) {
  const configUrl = sessionStorage.getItem("EMRBaseURL") + "/";
  const targetUrl =
    configUrl +
    "api/parkinglot/fetchPatientName?id=" +
    apptId;
  return fetch(targetUrl).then((response) => response.json());
}

export async function GetPracticeName() {
  const configUrl = sessionStorage.getItem("EMRBaseURL") + "/";
  const targetUrl =
    configUrl +
    "api/Provider/GetPracticeName"
  return fetch(targetUrl).then((response) => response.json());
}

export async function GetLink(id: any, flag: any) {
  let url: string =
    sessionStorage.getItem("EMRBaseURL") + "/" + "api/Provider/GetReviewLink?id=" + id + "&flag=" + flag;

  const response = await fetch(url);
  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.json();
  }
}

export async function updateReviews(reviewStars: number | null, reviewComments: string, sessionId: number) {
  const targetUrl =
    sessionStorage.getItem("EMRBaseURL") + "/" +
    "api/Provider/AddReview?reviewStars=" +
    reviewStars +
    "&reviewComments=" +
    reviewComments +
    "&sessionId=" +
    sessionId;
  const config = {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
  };
  const response = await fetch(targetUrl, config);
}

export async function sendReminder(id: number) {
  const targetUrl =
    sessionStorage.getItem("EMRBaseURL") + "/" +
    "api/Reminder/ImmediateReminderNotification?appointment_n=" +
    id +
    "&isPEAppt=" +
    true +
    "&employee_n="+0; //FB 10608;

  const config = {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
  };

  const response = await fetch(targetUrl, config);
  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
}

export async function PatientCellPhone(
  firstname: string,
  lastname: string,
  gender: any,
  dob: any
) {
  const cellphoneAPIUrl =
    sessionStorage.getItem("EMRBaseURL") + "/" +
    "api/Provider/GetPatientPhoneNumber?first_name=" +
    firstname +
    "&last_name=" +
    lastname +
    "&gender_n=" +
    gender +
    "&dateOfBirth=" +
    dob;

  const response = await fetch(cellphoneAPIUrl);
  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    return response.json();
  }
}

export async function GetdecodedURL(urlcode: string): Promise<string> {
  let url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/Provider/GetShortURL/${urlcode}`;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data;
  }
}

export function formatphone(phonenumber: any) {
  let phonenumberLink = "";
  if (phonenumber != "" && phonenumber != null && phonenumber != undefined) {
    phonenumber = phonenumber.replace(/[^0-9]/g, "");
    phonenumberLink = "tel:+1" + phonenumber;
    phonenumber = "(" + phonenumber.slice(0, 3) + ") " + phonenumber.slice(3, 6) + "-" + phonenumber.slice(6, 10);
  }
  else {
    phonenumber = "";
  }
  return (<a href={phonenumberLink} > {phonenumber}</a >);
}

export async function UploadDocuments(Documents: SupportFile[], appointment_n: number) {
  //FB 6925 KK Begin
  const result = await GetEMRURL();
  const TokenURL = result?.EMRURL + "/" + "api/GetAuthenticationToken/" + appointment_n;
  //FB 6925 KK End
  const response = await fetch(TokenURL);
  const AuthenticationToken = await response.json();

  if (!response.ok || AuthenticationToken.length <= 0) {
    var JSAlert = require("js-alert");
    JSAlert.alert("Authentication failed. Please try again later.", null, JSAlert.Icons.Warning);
  }
  else {
    const targetUrl = result?.EMRURL + "/" + "api/Convertbase64ToImage";//FB 6925 KK

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("token", AuthenticationToken[0].Token);

    const response = await fetch(targetUrl, {
      mode: 'cors',
      method: 'POST',
      headers: headers,
      body: JSON.stringify(Documents),
    });

    if (!response.ok) {
	//FB 8108 start
      if (response.status === 400) {
          NotifyVirusDetected();
      }else{
      NotifyErrorOutage();
      return Promise.reject();
      }
    }
	//FB 8108 end
    else {
      return response.status;
    }
  }
}

// FB 7541 - Begin
export async function UploadDocumentsFromPortal(Documents: SupportFileUpload[], patient_n: any) {
  const result = await GetEMRURL();
    const targetUrl = result?.EMRURL + "/" + "api/Convertbase64ToImagePortal";//FB 6925 KK

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("token",patient_n);

    const response = await fetch(targetUrl, {
      mode: 'cors',
      method: 'POST',
      headers: headers,
      body: JSON.stringify(Documents),
    });

    if (!response.ok) {
      if (response.status === 400) {  //FB 8108
          NotifyVirusDetected();
      }else{
      NotifyErrorOutage();
      return Promise.reject();
      }
    }
    else {
      return response.status;
    }
  }
// FB 7541 - End
//FB 9372
// export async function GetDocumentCategories() {
//   let url = sessionStorage.getItem("EMRBaseURL") + "/" + "api/GetDocumentCategories/FileUpload";
//   const response = await fetch(url).then((data) => data.json()).catch((error) => error);

//   return response;
// }

export async function GetLicenseName() {
  let url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/Provider/GetLicenseName`;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data;
  }
}

export async function GetPatientContactInfo(appointment_n: number) {
  let url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/Reminder/GetPatientContactInfoByAppt_N?id=${appointment_n}`;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data;
  }
}

export async function SendOTP(appointment_n: number, isPEAppt: boolean, send_email: number, send_text: number) {
  let url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/PatientIntake/UpdateVerificationCode?appointment_n=${appointment_n}
&isPEAppt=${isPEAppt}&emailSelect=${send_email}&phoneSelect=${send_text}`;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data;
  }
}

export async function GetOTP(appointment_n: number, isPEAppt: boolean) {
  let url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/PatientIntake/GetVerificationCode?appointment_n=${appointment_n}&isPEAppt=${isPEAppt}`;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data;
  }
}

export async function getTwilioToken(identity: string, room: string) {

  const generateToken = (config: any) => {
    return new AccessToken(
      Configurations.twilio.accountSid,
      Configurations.twilio.apiKey,
      Configurations.twilio.apiSecret
    );
  };

  const videoToken = (identity: any, room: any, config: any) => {
    let videoGrant;
    if (typeof room !== 'undefined') {
      videoGrant = new VideoGrant({ room });
    } else {
      videoGrant = new VideoGrant();
    }
    const token = generateToken(config);
    token.addGrant(videoGrant);
    token.identity = identity;
    return token;
  };

  const token = videoToken(identity, room, Configurations);
  if (identity == "patient")
    updateTelePatientDetails(1, parseInt(room));
  return token.toJwt();
}

export async function updateTelePatientDetails(isPatientJoined: number, appt_id: number) {
  const targetUrl =
    sessionStorage.getItem("EMRBaseURL") + "/" +
    "api/Provider/TeleHealth/UpdatePatientCallStatus?isPatientJoined=" +
    isPatientJoined +
    "&appt_id=" +
    appt_id;
  const config = {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
  };
  const response = await fetch(targetUrl, config);
  return response;
}

export async function UploadImages(Documents: InputFile, token: string) {

  const targetUrl = sessionStorage.getItem("EMRBaseURL") + "/" + "api/yii/saveimage";
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("token", token);
  const response = await fetch(targetUrl, {
    mode: 'cors',
    method: 'POST',
    headers: headers,
    body: JSON.stringify(Documents),
  });

  if (!response.ok) {
    return Promise.reject();
  }
  else {
    return response.status;
  }
}

export async function GetAppointmentType(appt_id: string) {
  let url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/Provider/GetAppointmentType?appt_id=` + appt_id;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data;
  }
}

export async function GetAdminSettingValue(setting: string) {
  let url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/Provider/GetAdminSettingValue?settingName=` + setting;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data;
  }
}

export async function GetAvailableSlotsByProvider(
  limited: number,
  startDate: string,
  id: number,
  apptType: any,
  insurance: number,  //FB 8024
  appointment_type_n: number  //FB 8024
): Promise<ProviderSchedule[]> {
  let url;
  if (apptType === "telederm") {
    url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/Provider/TeleHealth/GetSlotsForProvider/${id}/${startDate}/${limited}/${appointment_type_n}`;//FB 8024
  } else {
    url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/Provider/GetSlotsForProvider/${id}/${startDate}/${limited}/${insurance}/${appointment_type_n}`;//FB 8024
  }
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    data = data.sort(function (x: any, y: any) {
      return x.IsInsuranceAccepted === y.IsInsuranceAccepted ? 0 : x ? -1 : 1;
    });
    return data as ProviderSchedule[];
  }
}

export async function ReserveSlot(preRegObj: any) {
  const targetUrl = sessionStorage.getItem("EMRBaseURL") + "/" + "api/Provider/Schedule/Preregistration/AddSlot";
  const config = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    body: JSON.stringify(preRegObj),
  };
  const response = await fetch(targetUrl, config);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    const data = await response.json();
    return data;
  }
}

export async function GetAvailableSlotsByLocation(
  limited: number,
  startDate: string,
  id: number,
  insurance_id: number,//FB 8024
  appointment_type_n: number//FB 8024
): Promise<FacilitySchedule[]> {
  let url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/Provider/GetSlotsForFacility/${id}/${startDate}/${limited}/${insurance_id}/${appointment_type_n}`;//FB 8024
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    data = data.sort(function (x: any, y: any) {
      return x.isInsuranceAccepted === y.isInsuranceAccepted ? 0 : x ? -1 : 1;
    });
    return data as FacilitySchedule[];
  }
}

export async function GetAvailableSlotsByDate(
  startDate: string,
  location: number,
  provider: number,
  apptType: any,
  insurance_id: number,//FB 8024
  appointment_type_n : number //FB 8024
): Promise<SchedulesByDate[]> {
  let url;
  if (apptType === "telederm" && provider === 0) {
    url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/Provider/GetSlotsByDate/-1/${startDate}/1/${insurance_id}/${appointment_type_n}`;//FB 8024
  } else if (apptType === "telederm" && provider > 0) {
    url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/Provider/GetFacilitySlotsForProviderBydate/${provider}/-1/${startDate}/1/${insurance_id}/${appointment_type_n}`;//FB 8024
  } else if (provider === 0) {
    url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/Provider/GetSlotsByDate/${location}/${startDate}/1/${insurance_id}/${appointment_type_n}`;//FB 8024
  } else {
    url = sessionStorage.getItem("EMRBaseURL") + "/" + `api/Provider/GetFacilitySlotsForProviderBydate/${provider}/${location}/${startDate}/1/${insurance_id}/${appointment_type_n}`;//FB 8024
  }
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    if (apptType === "inoffice" && provider === 0) {
      data = data.sort(function (x: any, y: any) {
        return x.isInsuranceAccepted === y.isInsuranceAccepted ? 0 : x ? -1 : 1;
      });
    }
    return data as SchedulesByDate[];
  }
}

export async function NotifyErrorOutage() {
  var JSAlert = require("js-alert");
  JSAlert.alert("Something went wrong. Please try again later.", null, JSAlert.Icons.Warning);
}

export async function NotifyVirusDetected() { //FB 8108
  var JSAlert = require("js-alert");
  JSAlert.alert("Virus detected - file cannot be uploaded", null, JSAlert.Icons.Warning);
}

//FB 8549
export async function GetAppointmentTypes(filter:string,patientType:string) {
  let url = sessionStorage.getItem("EMRBaseURL") + `/api/Provider/Schedule/GetAppointmentTypes?filter=`+ filter + `&patientType=` + patientType;
  const response = await fetch(url);

  if (!response.ok) {
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    return data.map((key: any) => {
      return key as AppointmentType;
    });
  }
}